module.exports = __webpack_public_path__ + "static/x-7396fa0624ab6356a383cb8a6486eb40.png";